import { CHANGE_EXPORT_SETTINGS } from './types';

export const changeExportSettings = settings => ({
  type: CHANGE_EXPORT_SETTINGS,
  settings,
});
